import { Button } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ActionButtonsProps {
  isPending: boolean;
  showSaveButton?: boolean;
  saveButtonLabel?: string;
  onClickCancel: () => void;
  onClickConfirm?: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isPending,
  showSaveButton = true,
  saveButtonLabel,
  onClickCancel,
  onClickConfirm,
}) => {
  const { t } = useTranslation("common");
  return (
    <>
      <Button
        data-testid="cancel-btn"
        radius={8}
        color="gray"
        variant="outline"
        onClick={onClickCancel}
        ml={"sm"}
        type="button"
        tt={"uppercase"}
        loading={isPending}
      >
        {t("cancel")}
      </Button>
      {showSaveButton && (
        <Button
          radius={8}
          variant="filled"
          onClick={onClickConfirm}
          bg={"green"}
          data-testid="confirm-btn"
          loading={isPending}
          mr={"sm"}
          type="submit"
          tt={"uppercase"}
        >
          {saveButtonLabel ?? t("save")}
        </Button>
      )}
    </>
  );
};

export default ActionButtons;
